import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { PensionContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/PensionContributionInstruction";
import { PensionBenefitsInstructionDispatcher } from "../Store/Variable";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { SubAccountAmendmentInstructionClient } from "../../../../../../Wrap/Api/Apply/SubAccountAmendmentInstruction";
import { ProcessType as ActivityType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";

export class PensionBenefitsAction {
    public static getInstruction(id, type, hierarchyId, subAccountHierarchyId, clientId, onInstructionLoadedCallback: () => void = () => {}): void {
        const pensionContributionInstruction = new PensionContributionInstructionClient();
        if (CommonHelper.isNullOrEmpty(id)) {
            pensionContributionInstruction
                .post(subAccountHierarchyId, hierarchyId, ActivityType.TakePensionBenefit)
                .onSuccess((result) => {
                    const instructionId = result.Result;
                    const model = pensionContributionInstruction.get(instructionId, clientId, "", null);
                    model.onSuccess((result) => {
                        PensionBenefitsInstructionDispatcher.dispatch({
                            actionType: ActionType.Success,
                            payload: result,
                        });

                        onInstructionLoadedCallback();
                    });
                });
        } else {
            pensionContributionInstruction.get(id, clientId, null, null)
                .onSuccess((result) => {
                    PensionBenefitsInstructionDispatcher.dispatch({
                        actionType: ActionType.Success,
                        payload: result,
                    });

                    onInstructionLoadedCallback();
                });
        }
    }

    public static saveInstruction(from, data: any, customerId?: number, callback?: (data) => void): void {
        const pensionContributionInstruction = new PensionContributionInstructionClient();
        const promise = pensionContributionInstruction.put(data, customerId);
        promise.onSuccess((result) => {
            PensionBenefitsInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            if (result.Errors != null && result.Errors.length > 0) {
                callback(result.Errors.map((ele) => ele.UserMessage));
            } else {
                callback(result);
            }
        });

        promise.onError((err) => {
            PensionBenefitsInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static submitInstruction(id, data, customerId, claccountId, callback?: VoidFunction): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.put(id, data, customerId, claccountId);
        promise.onSuccess((result) => {
            if (callback) {callback();}
        });
    }

    public static deleteInstruction(id, callback?: VoidFunction): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.delete(id);
        promise.onSuccess((result) => {
            if (callback) {callback();}
        });
    }
}
